import { render, staticRenderFns } from "./mdf-pay-funds-widget.vue?vue&type=template&id=b921c736&"
import script from "./mdf-pay-funds-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-pay-funds-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-pay-funds-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports